import { type SiteResponse } from '@on3/api/src';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import { getAssetUrl } from '@on3/ui-lib/utils/images';
import { useMemo } from 'react';

import styles from './JoinSportsNetwork.module.scss';

interface JoinSportsNetworkProps {
  sites: SiteResponse[];
}

const mockData = [
  {
    avatarUrl: 'https://on3static.com/static/join/join-staples.jpg',
    name: 'Andy Staples',
    title: 'College Sports Host',
  },
  {
    avatarUrl: 'https://on3static.com/static/join/join-low.jpg',
    name: 'Chris Low',
    title: 'National Football',
  },
  {
    avatarUrl: 'https://on3static.com/static/join/join-mcmurphy.jpg',
    name: 'Brett McMurphy',
    title: 'National Football',
  },
  {
    avatarUrl: 'https://on3static.com/static/join/join-nakos.jpg',
    name: 'Pete Nakos',
    title: 'National Football',
  },
  {
    avatarUrl: 'https://on3static.com/static/join/join-dellenger.jpg',
    name: 'Ross Dellenger',
    title: 'National Football',
  },
  {
    avatarUrl: 'https://on3static.com/static/join/join-fo68.jpg',
    name: 'Field of 68',
    title: 'National Basketball',
  },
];

export const JoinSportsNetwork = ({ sites = [] }: JoinSportsNetworkProps) => {
  const sampleSiteLogos = useMemo(() => {
    const siteLogos = new Set<string>();

    sites
      .filter((s) => !!s.organization?.defaultAssetRes)
      .sort(() => 0.5 - Math.random())
      .forEach((s) => {
        siteLogos.add(getAssetUrl(s.organization!.defaultAssetRes) || '');
      });

    return Array.from(siteLogos).slice(0, 32);
  }, [sites]);

  return (
    <section>
      <div className={styles.container}>
        <header className={styles.header}>
          <h2>On3 College Sports Network</h2>
        </header>
        <div className={styles.content}>
          <div className={styles.section}>
            <h3>On3 National College voices you trust</h3>
            <div className={styles.people}>
              {mockData.map((person) => (
                <dl className={styles.person} key={person.name}>
                  <Avatar height={120} source={person.avatarUrl} width={120} />
                  <dt>{person.name}</dt>
                  <dd>{person.title}</dd>
                </dl>
              ))}
            </div>
            <p className={styles.more}>And others!</p>
          </div>
          <div className={styles.section}>
            <h3>Full network access</h3>
            <p>Insider coverage from every fan site across the On3 Network</p>
            <div className={styles.sites}>
              {sampleSiteLogos.map((logo) => (
                <div key={logo}>
                  <Avatar height={50} source={logo} teamAvatar width={50} />
                </div>
              ))}
            </div>
            <p className={styles.more}>And many more!</p>
          </div>
        </div>
      </div>
    </section>
  );
};
